const WhatsAppContent = {
  overview: {
    title: "inFlow WhatsApp AI",
    description:
      "Deploy intelligent WhatsApp AI agents that handle multi-turn conversations, order placement, customer inquiry resolution, and automated transactional alerts at global enterprise scale.",
    imageURL: "/images/products/WhatsApp-3D-Studio-Banner.png",
    screenURL: "/images/products/WhatsApp-3D-Studio-Banner.png",
  },
  demo: [
    {
      title: "Restaurant Agent",
      path: "/demo/restaurant-agent",
      tag: "text",
      image: "/images/products/demo-whatsApp.png",
      description: [
        "Lets customers browse menus, book tables, and place delivery orders directly via WhatsApp, with instant confirmations.",
      ],
      url: "https://wa.me/+919566872907?text=Hi",
    },
    {
      title: "Order Intake Agent",
      path: "/demo/order-intake-agent",
      tag: "text",
      image: "/images/products/demo-whatsApp.png",
      description: [
        " Captures orders from messages, voice notes, or images, verifies details, and syncs seamlessly with order management systems.",
      ],
      url: "https://wa.me/+6581342734?text=Hi",
    },
    {
      title: "University Agent",
      path: "/demo/university-agent",
      tag: "text",
      image: "/images/products/demo-whatsApp.png",
      description: [
        "Engages students and parents on WhatsApp with quick answers on courses, admissions, and campus life, available 24/7.",
      ],
      url: "https://wa.me/+6594586274?text=Hi",
    },
    {
      title: "Retail Agent",
      path: "/demo/retail-agent",
      tag: "text",
      image: "/images/products/demo-whatsApp.png",
      description: [
        "Enables shoppers to browse products, check availability, and place orders, while offering promotions and personalized recommendations.",
      ],
      url: "https://wa.me/+918056569401?text=Hi",
    },
    {
      title: "Dental Agent",
      path: "/demo/dental-agent",
      tag: "text",
      image: "/images/products/demo-whatsApp.png",
      description: [
        "Simplifies appointment bookings, reminders, and treatment inquiries, creating a convenient patient experience on WhatsApp.",
      ],
      url: "https://wa.me/+914447455633?text=Hi",
    },
    {
      title: "Lead Generation Agent",
      path: "/demo/lead-generation-agent",
      tag: "text",
      image: "/images/products/demo-whatsApp.png",
      description: [
        "Qualifies leads through smart conversation flows, collects prospect details, and routes them instantly to sales teams.",
      ],
      url: "https://wa.me/+60147615674?text=Hi",
    },
     {
      title: "Expense Claim Agent ",
      path: "/demo/expense-claim-agent –",
      tag:"text",
      // image: "/Images/demo-whatsApp.png",
      description: [
        "Automates claim submissions via WhatsApp, extracting details from receipts and generating status updates in real time.",
      ],
      url: "https://wa.me/+6580699247?text=Hi",
    },
    {
      title: "Customer Support Agent",
      path: "/demo/customer-support-agent",
      tag:"text",
      // image: "/Images/demo-whatsApp.png",
      description: [
        " Provides L1 support, raises tickets, shares status updates and logs feature requests, all on WhatsApp.",
      ],
        url: "https://wa.me/+6580854159?text=Hi",
      },
      {
      title: "WhatsApp calling",
      path: "/demo/whatsapp-calling",
      // image: "/Images/demo-whatsApp.png",
      tag:"voice",
      description: [
        " Business or customer initiated WhatsApp calls with AI voice support, seamless live agent escalation, and faster resolution end to end.",
      ],
        url: "https://test-whatsapp-calling.inextlabs.ai",
      },
      {
      title: "Healthcare Assistant",
      path: "/demo/healthcare-assistant",
      tag:"text",
      // image: "/Images/demo-whatsApp.png",
      description: [
        "AI assistant for general queries, doctor discovery, appointment booking, rescheduling, reminders, and patient support on WhatsApp.",
      ],
        url: "https://wa.me/+916374015979?text=Hi",
      },
    ],
  resources: {
    diagrams: [
      {
        name: "WhatsApp Calling Brochure",
        type: "pdf",
        tag: "PDF",
        image: "brochure/whatsappCalling.pdf",
        size: "PDF · 850 KB",
        desc: "Interactive voice calling and AI agent integration guide for WhatsApp.",
        isHero: true,
      },
      {
        name: "Smart Ordering Brochure",
        type: "pdf",
        tag: "PDF",
        image: "brochure/smartOrdering.pdf",
        size: "PDF · 1.3 MB",
        desc: "Detailed breakdown of conversational commerce and order processing capabilities.",
      },
      {
        name: "WhatsApp Bot Architecture",
        type: "diagram",
        tag: "DIAGRAM",
        image: "architecture/WhatsApp_Bot_Architecture.png",
        size: "PNG · 410 KB",
        desc: "End-to-end messaging pipeline, webhook integration, and LLM orchestration topology.",
      },
    ],
  },
};

export default WhatsAppContent;
